<style scoped>
.wrapUn {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 10px;
  height: 100%;
}
main {
  flex: 1;
  padding: 10px;
  display: flex;
  overflow-y: auto;
}
.pieChart {
  flex: 1;
}
</style>

<template>
  <div class="wrapUn">
    <dimension-dialog
      v-if="showExport"
      @hideExport="hideExport1"
      :moduleName="moduleName"
      :autoChunkMonth="true"
      :tab="dataType"
    />
    <div class="map-search">
      <div class="map-title" style="height: auto">
        <el-row>
          <CardHeader :title="title" />
          <el-select
            v-model="fuelType"
            @change="changeFuelType"
            style="
              line-height: initial;
              width: 150px;
              position: absolute;
              right: 240px;
              top: 22px;
            "
            placeholder="请选择燃油类型"
          >
            <el-option
              v-for="(item, index) in fuelTypeList"
              :label="item.label"
              :value="item.value"
              :key="index"
            />
          </el-select>
          <el-button
            style="position: absolute; right: 20px; top: 22px"
            @click="exportDate"
            v-show="hideExport"
            >导出</el-button
          >
          <el-button
            style="position: absolute; right: 120px; top: 22px"
            v-if="utype != 2"
            @click.native="goBack"
            >返回上级</el-button
          >
        </el-row>
        <el-row style="margin-left: 15px">
          <dimension-popover
            ref="objDimensionPopover"
            :isMapValue="true"
            :dimObj="dimObj"
            :change="changeDimension"
            :showBottomButton="false"
            :isItemBindClick="true"
          />
        </el-row>
      </div>
      <map-data-table
        :areaList="areaList"
        v-if="areaList && areaList.length > 0"
        :changeCity="changeCity"
      ></map-data-table>
    </div>
    <main v-show="height > 0">
      <Pie :pieData="pieData" :allNumber="allNumber" :height="height" />
    </main>
    <!-- <div>
      暂无数据
    </div> -->
    <div class="bottom-top">
      <h4>
        <img src="../../../assets/images/title.png" />
        <span>说明</span>
      </h4>
      <div>1.车辆途经地区：重载货车行驶运营的地市/地区。</div>
      <div>2.途经车辆注册省份：重载货车登记入网的省份，即车籍地。</div>
      <div>3.里程统计：统计时间内，车辆途经城市里程汇总。
      【举例】点击车辆途经地区“北京-朝阳”，页面显示里程数含义为：①合计XX：全国各地重载货车在北京市朝阳区行驶里程为XX万公里；②北京XX：北京车牌的重载货车在北京市朝阳区行驶里程为XX万公里；③河北XX：河北车牌的重载货车在北京市朝阳区行驶里程为XX万公里。以此类推。</div>
      <div>4.统计频率：按月统计，每月6日更新上月数据。</div>
    </div>
  </div>
</template>
<script>
/**
 * @file:  View 页面 途经各省份运营里程数据--> 详情
 * @author: v_chengmengya
 * @date: 2019-05-20
 * @description: 页面 包含tab 柱状图
 */
import Pie from './components/pie' // 柱状图
import mapDataTable from './components/mapDataTable' // tab切换
import CardHeader from './components/cardHeader' // title
import http from '@/api/freight' // 请求汇总
import Util from '@/utils/util'
import Cookies from 'js-cookie'
import { hideExport } from '@/utils/tools'
import dimensionPopover from '@/components/exportDate/daphne/popover.vue'
import dimensionDialog from '@/components/exportDate/daphne/dialog.vue'
import cloneDeep from 'lodash/cloneDeep'
import get from 'lodash/get'
import set from 'lodash/set'
import each from 'lodash/each'
import { getFuelTypeList, getFuelTypeCode } from '@/utils/dictionary'
export default {
  components: {
    CardHeader,
    mapDataTable,
    dimensionPopover,
    dimensionDialog,
    Pie,
  },
  data() {
            let defaultTime1 = this.$route.query.yearMonth
      ? this.$route.query.yearMonth.substr(0, 4) +
        '-' +
        this.$route.query.yearMonth.substr(4, 6)
      : Util.lastTime()

    let defaultTime = defaultTime1
    let fuelTypeList = getFuelTypeList()
    let value4 = Util.lastTime(new Date())
    let arr = defaultTime.split('-')
    let dimObj = {
      year: arr[0],
      month: arr[1],
      type: '0',
    }
    return {
      fuelType: '',
      fuelTypeList,
      dataType: 1,
      hideExport: hideExport,
      moduleName: 'pathwayCityOperator', //
      areaList: [],
      title: '',
      pieData: [], //['amount', 'product']
      allNumber: 0, //总计
      defaultTime: '', // 默认时间
      height: '',
      index: 0,
      code: '',
      pcode: '',
      progressNum: 0, //进度条进度
      mark: false, //是否显示遮罩层
      showExport: false, //控制批量导出
      proCode: '', //省份code
      utype: 0,
      isNumOne: true,
      dimObj,
      value4,
      firstPageLoad:'1'
    }
  },
  created() {
    // 初始化title
    let str = this.$route.query.title || this.$route.query.provinceName || ''
    this.pcode = this.$route.query.code || this.$route.query.provinceCode
    let title = `货运平台车辆途经${str}各地区里程统计`
    this.title = title
    let proCode = this.$route.query.proCode || this.$route.query.provinceCode
    this.proCode = proCode
  },
  mounted() {
    this.utype = Cookies.get('userType')
    this.getParents()
    this.initData()
  },
  methods: {
    changeDimension(e) {
      if (e.isOk) {
        let type = e.type
        let arr = get(this, ['dimsTitle', type], [])
        each(arr, (title, index) => {
          if (title) {
            set(this, ['titleArr', index, 'title'], title)
          }
        })
        this.value4 = e.year + '-' + e.month
        this.dimObj.year = e.year
        this.dimObj.month = e.month
        this.dimObj.type = type
        this.changeData()
      }
    },
    // 取消导出
    hideExport1() {
      this.showExport = false
    },
    changeData() {
      // 时间选择器
      let that = this
      let index = that.index
      if (index == 0) {
        this.getParents()
      } else {
        that.initPie(this.code)
      }
    },
    changeCity(index, code) {
      //tab切换
      let that = this
      that.index = index
      if (index == 0) {
        this.code = ''
        this.getParents()
      } else {
        that.code = code
        that.initPie(code)
      }
    },
    async initData() {
      let that = this
      let params = {
        provname: this.$route.query.title || this.$route.query.provinceName,
      }
      let { code, data } = await http.carTrainsDetailCity(params)
      if (code == 200 && data) {
        let arr = data
        that.areaList = arr.slice(0)
      } else {
        that.areaList = []
      }
    },
    changeFuelType() {
      this.changeData()
    },
    async initPie(pathWayCityCode) {
      let that = this
      let pieData = []
      let params = {
        pathWayCityCode,
        year: that.dimObj.year,
        month: that.dimObj.month,
        timeType: get(that, 'dimObj.type', '0'),
        dataType: that.dataType,
        fuelType: getFuelTypeCode(that.fuelType),
      }
      let { code, data } = await http.carTrainsDetailPie(params)
      if (code == 200 && data) {
        let arr = that.initArr(data.resultList)
        that.initHeight(data.resultList)
        arr.reverse()
        let endArr = arr ? pieData.concat(arr) : null
        that.pieData = endArr.slice(0)
        that.allNumber = data.sum
      } else {
        that.pieData = []
        that.allNumber = 0
        that.height = 0
      }
    },
    initArr(arr) {
      // 初始化数组函数
      if (arr && arr.length) {
        let Narr = []
        let arr1 = arr.slice(0) // 拷贝数组
        arr1.forEach((item, index) => {
          Narr[index] = [item.mile, item.registProvince]
        })
        return Narr
      }
      return false
    },
    async getParents() {
      let timeType = get(this, 'dimObj.type', '0')
      let that = this
      let pieData = []
      let yearMonth = this.dimObj.year + this.dimObj.month
      let params = {
        dataType: that.dataType,
        timeType,
        fuelType:  getFuelTypeCode(that.fuelType),
        yearMonth,
        proCode: this.$route.query.proCode || this.$route.query.provinceCode,
        countryIs: this.$route.query.countryIs || 1,
        cityfirst: this.utype == 2 && this.isNumOne ? '1' : '0',
        firstPageLoad:this.firstPageLoad
      }
      let { code, data } = await http.carTrains(params)
              if(this.utype==2&&this.firstPageLoad){
              that.firstPageLoad=0
              that.value4=data.time;
              let arr = that.value4.split('-')
              set(this,"dimObj.year",arr[0])
              set(this,"dimObj.month",arr[1])
              that.$refs.objDimensionPopover.setCtrlValue()

        }
      if (code == 200 && data.list) {
        that.isNumOne = false
        that.defaultTime = data.time
        let arr = that.initArr(data.list)
        let endArr = arr ? pieData.concat(arr) : false
        if (!endArr) {
          that.pieData = []
          return
        }
        that.initHeight(endArr)
        endArr.reverse()
        let end = endArr.slice(0)
        end.unshift(['amount', 'product'])
        that.pieData = end.slice(0)
        that.allNumber = data.mileSum
      } else {
        that.pieData = []
      }
    },
    initHeight(data) {
      // 初始化柱状图高度
      const that = this
      const length = data.length
      if (length <= 5) {
        that.height = length * 60 + 40
      } else {
        that.height = length * 50 + 40
      }
    },
    goBack() {
      // 返回上级
      this.$router.push({
        name: 'carMileViaProvince',
      })
    },
    exportDate() {
      this.showExport = true
      return
    },
  },
}
</script>
